var _rect, _circle, _circle2, _g, _path, _path2, _g2, _g3, _circle3, _circle4, _circle5, _circle6, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWingoRound5M(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 30,
    fill: "url(#paint0_linear_55_15983)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "url(#paint1_linear_55_15983)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55_15983",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "url(#paint2_linear_55_15983)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55_15983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 52L18.5 48L15.5 31L36 23L40 24L61.5 19.5003L105.126 53.9162L108 52L106.5 55.0003L105.126 53.9162L105 54L98 61.5L65.5 97.5003L21 61.0003L24 52Z",
    fill: "#4361C6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 55H7L12 61L9 55Z",
    fill: "#F4DE6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9866 9.35221L64.4014 12.9377C64.5402 13.2894 65.0006 13.3721 65.253 13.0907C65.3749 12.9549 65.4147 12.7641 65.3572 12.5909L64.1434 8.93242C63.9821 8.44624 63.3322 8.35828 63.0475 8.78409C62.9352 8.952 62.9124 9.16432 62.9866 9.35221Z",
    fill: "#72FBBF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_55_15983)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 36.5,
    r: 29.5,
    fill: "url(#paint3_linear_55_15983)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_55_15983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5168 36.0998C25.9086 36.1565 24.5892 35.9439 23.5588 35.4619C22.153 34.8034 21.0356 33.7562 20.2066 32.3204C18.8446 29.9614 18.8396 27.3916 20.1915 24.6111C21.2561 22.458 23.2115 20.5599 26.0577 18.9166C29.8269 16.7405 33.0234 15.8522 35.6473 16.2518C38.284 16.6441 40.2315 17.9299 41.4898 20.1094C42.2226 21.3786 42.5483 22.7718 42.4669 24.2888C42.4022 25.4202 42.015 26.7036 41.3052 28.139C43.2528 27.989 44.9462 28.3018 46.3856 29.0777C47.8378 29.8461 48.9858 30.961 49.8296 32.4226C50.6438 33.8328 51.0793 35.3421 51.136 36.9503C51.1982 38.5384 50.9474 39.9396 50.3835 41.154C49.8325 42.361 48.9407 43.5255 47.7081 44.6474C46.4958 45.7747 45.0947 46.7973 43.505 47.7151C40.5178 49.4397 38.0322 50.4047 36.0482 50.61C34.0641 50.8153 32.2659 50.4689 30.6534 49.5709C29.0409 48.6728 27.7461 47.3776 26.769 45.6853C25.8142 44.0315 25.392 42.412 25.5024 40.8269C25.6055 39.2289 26.277 37.6532 27.5168 36.0998ZM27.8384 28.5295C28.401 29.5039 29.1575 30.1184 30.1079 30.373C31.0638 30.6075 32.0481 30.4323 33.0609 29.8476C33.9584 29.3295 34.5253 28.609 34.7617 27.6862C34.9982 26.7633 34.8462 25.834 34.3059 24.8981C33.7433 23.9237 32.9868 23.3092 32.0364 23.0545C31.0785 22.787 30.1317 22.9235 29.1958 23.4638C28.2471 24.0115 27.6454 24.7606 27.3907 25.7111C27.1414 26.6413 27.2907 27.5808 27.8384 28.5295ZM34.4212 40.9083C35.1392 42.1519 36.1059 42.9528 37.3212 43.311C38.5291 43.6563 39.6203 43.5477 40.5946 42.9851C41.5305 42.4448 42.1408 41.5625 42.4255 40.3384C42.7027 39.1014 42.4861 37.8675 41.7755 36.6367C41.0575 35.3931 40.0909 34.5923 38.8755 34.2341C37.673 33.8685 36.5782 33.9707 35.591 34.5407C34.6167 35.1032 33.9862 35.9801 33.6995 37.1712C33.4257 38.3549 33.6663 39.6006 34.4212 40.9083Z",
    fill: "#4F75F4"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 80,
    r: 7,
    fill: "#2AD2F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 77.5,
    r: 4.5,
    fill: "white",
    fillOpacity: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 82.5,
    r: 5.5,
    fill: "#D078C2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 80.5,
    r: 3.5,
    fill: "white",
    fillOpacity: 0.2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_55_15983)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 64,
    r: 19,
    fill: "url(#paint4_linear_55_15983)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_55_15983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8945 60.9743C62.338 60.0845 62.0279 59.27 61.9642 58.5309C61.8776 57.5222 62.1047 56.5497 62.6453 55.6133C63.5335 54.0749 64.9832 53.2341 66.9944 53.091C68.5576 52.9902 70.2672 53.4756 72.1233 54.5472C74.5814 55.9664 76.1254 57.4821 76.7553 59.0943C77.3935 60.7113 77.3024 62.2305 76.4817 63.6519C76.0039 64.4796 75.3232 65.1178 74.4399 65.5665C73.7798 65.8989 72.9287 66.0987 71.8866 66.1659C72.6064 67.2169 72.9819 68.2753 73.0131 69.3412C73.0526 70.4119 72.7972 71.4239 72.2469 72.377C71.7159 73.2967 71.0055 74.0348 70.1157 74.5912C69.2391 75.1442 68.3659 75.4594 67.4962 75.537C66.6349 75.6193 65.6864 75.4954 64.6509 75.165C63.6189 74.8479 62.5845 74.3901 61.5477 73.7915C59.5997 72.6668 58.2442 71.5776 57.4813 70.524C56.7184 69.4704 56.3277 68.3419 56.3091 67.1383C56.2905 65.9348 56.5998 64.7812 57.237 63.6776C57.8597 62.599 58.6366 61.8325 59.5679 61.378C60.504 60.9151 61.6129 60.7806 62.8945 60.9743ZM67.2749 58.6874C66.908 59.3229 66.8076 59.9505 66.9737 60.5703C67.153 61.1866 67.5729 61.6855 68.2334 62.0668C68.8186 62.4047 69.4104 62.49 70.0087 62.3226C70.607 62.1552 71.0823 61.7664 71.4347 61.156C71.8016 60.5206 71.902 59.893 71.7359 59.2731C71.5746 58.6449 71.1888 58.1546 70.5785 57.8023C69.9598 57.445 69.3405 57.3495 68.7207 57.5156C68.114 57.6781 67.6321 58.0687 67.2749 58.6874ZM62.4301 66.4417C61.9619 67.2527 61.8247 68.0598 62.0187 68.863C62.2176 69.6578 62.6347 70.2386 63.2701 70.6055C63.8805 70.9579 64.5778 71.0149 65.362 70.7765C66.151 70.5297 66.7772 70.005 67.2406 69.2024C67.7089 68.3914 67.846 67.5843 67.652 66.7811C67.4663 65.9827 67.0516 65.3977 66.4078 65.026C65.7724 64.6592 65.0716 64.589 64.3054 64.8155C63.5476 65.0468 62.9225 65.5889 62.4301 66.4417Z",
    fill: "url(#paint5_linear_55_15983)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_55_15983",
    x: 5,
    y: 3,
    width: 62,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.226188 0 0 0 0 0.394812 0 0 0 0 0.948861 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_55_15983"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_55_15983",
    x: 19.1814,
    y: 16.1588,
    width: 35.9639,
    height: 38.5085,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.453987 0 0 0 0 0.992157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_15983"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_15983",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_55_15983"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_55_15983",
    x: 48,
    y: 42,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.509804 0 0 0 0 0.839216 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_55_15983"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_55_15983",
    x: 52.3083,
    y: 53.078,
    width: 24.8657,
    height: 26.4837,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.152941 0 0 0 0 0.490196 0 0 0 0 0.827451 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_15983"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_15983",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_15983",
    x1: 88,
    y1: 0.0000104904,
    x2: 0.0000104904,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55_15983",
    x1: 18.2912,
    y1: 0.00000128686,
    x2: 69.7088,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F9CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A89E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_55_15983",
    x1: 18.2912,
    y1: 0.00000128686,
    x2: 69.7088,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F9CFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A89E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_55_15983",
    x1: 8,
    y1: 7,
    x2: 67,
    y2: 66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_55_15983",
    x1: 86,
    y1: 45,
    x2: 48,
    y2: 83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72B8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72B8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_55_15983",
    x1: 72.4243,
    y1: 54.721,
    x2: 61.4474,
    y2: 73.7336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWingoRound5M);
export default __webpack_public_path__ + "static/media/wingo_round_5m.9b46b08c9e09e25673c8312222013b62.svg";
export { ForwardRef as ReactComponent };